import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  logo: {
    height: '150px',
    width: '150px',
    margin: 0,
    objectFit: 'cover',
    borderRadius: '50%',
  },
  root: {
    position: 'relative',
  },
  iconButton: {
    zIndex: 1,
    position: 'absolute',
    right: '-20px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  icon: {
    marginRight: '5px',
  },
}));